import React from 'react'

// Lazy loading
import loadable from '@loadable/component'

interface FormShellProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_Form
  location?: any
}

interface PostProps {
  [key: string]: any
}

const FormShell: React.FC<FormShellProps> = ({ fields, location = {} }) => {
  const types: PostProps = {
    contact: loadable(() => import('components/flex/Form/FormContact')),
  }

  if (!fields.styletype || !types[fields.styletype]) {
    return null
  }

  const Component = types[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default FormShell
